var map = {
	"./7.mp3": "4c40",
	"./E_action.mp3": "cc97",
	"./E_illustration.mp3": "ffde",
	"./E_talk.mp3": "0a92",
	"./I_action.mp3": "e898",
	"./I_illustration.mp3": "ab3a",
	"./I_talk.mp3": "b13d",
	"./O_action.mp3": "83bd",
	"./O_illustration.mp3": "d934",
	"./O_talk.mp3": "8ed3",
	"./Shva_i.mp3": "a387",
	"./Shva_illustration.mp3": "4353",
	"./Shva_talk.mp3": "6fdd",
	"./U_action.mp3": "ca49",
	"./U_illustration.mp3": "1c22",
	"./U_talk.mp3": "169a",
	"./belt_center_talk.mp3": "9045",
	"./black_belt_center.mp3": "7f27",
	"./ceremony_sound.mp3": "56dc",
	"./click_on_belt.mp3": "19ed",
	"./congratulations.mp3": "3676",
	"./dance_mid.mp3": "e6f8",
	"./dance_song.mp3": "f621",
	"./dance_start.mp3": "6b41",
	"./game_final.mp3": "40df",
	"./great.mp3": "cabf",
	"./introduction.mp3": "4b8b",
	"./level_center_talk.mp3": "858b",
	"./new_belt.mp3": "702d",
	"./ready.mp3": "a21e",
	"./select_game_or_tutorial.mp3": "0a34",
	"./unlock.mp3": "ff9d",
	"./white_belt_A.mp3": "ede5",
	"./white_belt_illustration.mp3": "0c68",
	"./white_belt_intro.mp3": "a0ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "776c";